import { createClient, createPrintManager, version } from './index'
import type { Client, PrintManager } from './types'

/**
 * UMD 入口：将 API 暴露到浏览器全局对象
 */
export { createClient, createPrintManager, version }

declare global {
  interface Window { PrintSDK?: any }
}

/**
 * 在浏览器环境下挂载到 window.PrintSDK
 */
if (typeof window !== 'undefined') {
  (window as any).PrintSDK = { createClient, createPrintManager, version }
}
